/**
 * 韩语（ko）
 */

import koLocale from 'element-ui/lib/locale/lang/ko'

export default {
  ...koLocale,
  common: {},
  // 语言
  lang: {
    english: '영어.',
    spanish: '스페인',
    japanese: '일본 인',
    portuguese: '포르투갈 어',
    french: '불어',
    russian: '러시아어',
    arabic: '아랍 어',
    german: '독일의',
    italian: '이탈리아 사람',
    vietnam: '월 남',
    turkey: '터키',
    korean: '한국 사람',
    thai: '태국 사람',
    dutch: '네덜란드 어',
    hebrew: '히 브 리 어',
    indonesian: '인도네시아'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
